export default __webpack_public_path__ + "images/philosopher.3ce2b478.png";